export { default } from "./ComponentReplacer";
